/* eslint-disable @typescript-eslint/no-var-requires */
const { paths } = require('./paths')
const { slugs } = require('./slugs')

module.exports = {
  paths,
  slugs,
}
